import { FC, ReactNode } from 'react';
import { cn } from '@/utils/cn';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  variant?: 'default' | 'glass' | 'bordered';
}

export const Card: FC<CardProps> = ({
  children,
  className,
  hover = false,
  variant = 'default',
}) => {
  const variants = {
    default:  'bg-white shadow-apple',
    glass:    'glass shadow-apple',
    bordered: 'bg-white border border-apple-separator',
  };

  return (
    <div
      className={cn(
        'rounded-apple p-6',
        variants[variant],
        hover && 'transition-shadow duration-300 hover:shadow-apple-md cursor-pointer',
        className
      )}
    >
      {children}
    </div>
  );
};
